// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1xEzY","inner":"Footer_inner__23WyX","nextIcon":"Footer_nextIcon__235Zv","innerLeft":"Footer_innerLeft__Vd5Dr"};